<template>
  <div class="line-callback-container">
    <div class="loading-wrapper" v-if="isProcessing">
      <div class="loading-spinner"></div>
      <h2>處理中...</h2>
      <p>正在完成 LINE 登入，請稍候</p>
    </div>

    <div class="error-wrapper" v-if="hasError">
      <div class="error-icon">❌</div>
      <h2>登入失敗</h2>
      <p>{{ errorMessage }}</p>
      <button @click="redirectToLogin" class="retry-btn">重新登入</button>
    </div>
  </div>
</template>

<script>
import api from "@/assets/js/api";
import Cookies from "js-cookie";
import Auth from "@/assets/js/auth";
import Swal from "sweetalert2";

export default {
  name: "LineCallbackPage",

  data() {
    return {
      isProcessing: true,
      hasError: false,
      errorMessage: "",
    };
  },

  created() {
    this.handleLineCallback();
  },

  methods: {
    async handleLineCallback() {
      console.log("LINE 回調頁面開始處理...");

      try {
        // 從 URL 參數中取得授權碼
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get("code");
        const state = urlParams.get("state");
        const error = urlParams.get("error");

        console.log("URL 參數:", { code, state, error });

        // 檢查是否有錯誤
        if (error) {
          throw new Error(`LINE 授權失敗: ${error}`);
        }

        if (!code) {
          throw new Error("未取得授權碼，請重新嘗試登入");
        }

        console.log("發送授權碼到後端:", { code, state });

        // 將授權碼發送到後端處理
        const response = await api.post("/Line/callback", {
          code: code,
          state: state,
        });

        console.log("後端回應:", response);

        if (response.data && response.data.success) {
          const { token } = response.data;

          if (token) {
            // 儲存 token 到 Cookies
            Cookies.set("token", token, { expires: 7 });

            // 顯示成功訊息
            await Swal.fire({
              icon: "success",
              title: "LINE 登入成功！",
              text: "正在跳轉到您的專屬頁面...",
              showConfirmButton: false,
              timer: 2000,
            });

            // 清除 URL 參數並跳轉
            window.history.replaceState({}, document.title, "/line-callback");
            Auth.redirectToRolePage(this.$router);
          } else {
            throw new Error("後端未返回登入憑證");
          }
        } else {
          throw new Error(response.data?.message || "LINE 登入處理失敗");
        }
      } catch (error) {
        console.error("LINE 回調處理錯誤:", error);

        this.isProcessing = false;
        this.hasError = true;
        this.errorMessage =
          error.response?.data?.message ||
          error.message ||
          "登入過程發生錯誤，請重新嘗試";
      }
    },

    redirectToLogin() {
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
.line-callback-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #00b900 0%, #00d300 100%);
  font-family: "Arial", sans-serif;
}

.loading-wrapper,
.error-wrapper {
  background: white;
  padding: 3rem;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 400px;
  width: 90%;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #00b900;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.error-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.loading-wrapper h2,
.error-wrapper h2 {
  color: #333;
  margin-bottom: 1rem;
  font-size: 1.5rem;
}

.loading-wrapper p,
.error-wrapper p {
  color: #666;
  margin-bottom: 2rem;
  line-height: 1.5;
}

.retry-btn {
  background: #00b900;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 25px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s ease;
}

.retry-btn:hover {
  background: #009900;
}
</style>
